import axios from 'axios';
import { isMobile } from 'react-device-detect';
import { TRAFFIC_JUNKY_EVENTS } from '@/common/contexts/tracking/tracking.constants';

const QUIZ_IP_STATS_EVENTS = {
	PURCHASE: 'AD_QUIZ_PURCHASE',
	PURCHASE_PROMO: 'AD_QUIZ_PURCHASE_PROMO',
};

const PURCHASE_DEDUP_PREFIX = 'quiz_purchase_tracked_';

const readStorage = (key) => {
	try {
		return localStorage.getItem(key);
	} catch {
		return null;
	}
};

const markTrackedOnce = (dedupeKey) => {
	try {
		if (sessionStorage.getItem(dedupeKey)) {
			return false;
		}
		sessionStorage.setItem(dedupeKey, '1');
		return true;
	} catch {
		return true;
	}
};

const trackQuizFbPurchase = (payload) => {
	const eventData = {};

	if (payload.purchaseValue != null) {
		eventData.value = payload.purchaseValue;
	}

	if (payload.purchaseCurrency) {
		eventData.currency = payload.purchaseCurrency;
	}

	payload.trackFacebookEvent({
		eventName: 'Purchase',
		eventData,
	});
};

const resolveAdvertBackendUrl = () => {
	const configured = import.meta.env.VITE_ADVERT_BACKEND_URL?.trim();

	if (!configured) {
		return null;
	}

	return configured.replace(/\/?$/, '/');
};

const buildUtmPayload = () => ({
	utm_campaign: readStorage('utm_campaign'),
	utm_medium: readStorage('utm_medium'),
	utm_source: readStorage('utm_source'),
	utm_content: readStorage('utm_content'),
	utm_fbclid: readStorage('fbclid'),
	utm_term: readStorage('utm_term'),
	uid: readStorage('uid'),
	msclkid: readStorage('msclkid'),
});

const trackQuizIpStatsPurchase = async (payload) => {
	const advertBackendUrl = resolveAdvertBackendUrl();

	if (!advertBackendUrl) {
		console.warn(
			'[quiz-purchase] VITE_ADVERT_BACKEND_URL is missing — IP stats purchase skipped',
		);
		return;
	}

	const eventType = payload.isPromo
		? QUIZ_IP_STATS_EVENTS.PURCHASE_PROMO
		: QUIZ_IP_STATS_EVENTS.PURCHASE;

	await axios.post(`${advertBackendUrl}browsing-person-stat`, {
		browsing_person: payload.browsingPersonId || readStorage('bp') || undefined,
		type: eventType,
		utm: buildUtmPayload(),
		device_type: isMobile ? 'mobile' : 'desktop',
		device_description: window.navigator.userAgent,
		lang: payload.lang,
		quiz_variant: 'STUDIO',
	});
};

export const trackVerifiedQuizPurchaseOnce = async (payload) => {
	const browsingPersonId =
		payload.browsingPersonId || readStorage('bp') || undefined;

	const dedupeId = payload.paymentIntent || browsingPersonId || payload.email;

	if (!dedupeId) {
		return;
	}

	const dedupeKey = `${PURCHASE_DEDUP_PREFIX}${dedupeId}`;

	if (!markTrackedOnce(dedupeKey)) {
		return;
	}

	trackQuizFbPurchase(payload);

	payload.trackTrafficJunkieEvent({
		event: TRAFFIC_JUNKY_EVENTS.PURCHASE,
		browsingPersonId,
		description: `QuizPurchase+${payload.paymentFor || 'plan'}+Stripe+${browsingPersonId || payload.paymentIntent}`,
	});

	try {
		await trackQuizIpStatsPurchase({
			...payload,
			browsingPersonId,
		});
	} catch (error) {
		console.error('[quiz-purchase] IP stats purchase failed', error);
	}
};
